import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { MaintenanceReports } from './MaintenanceReports';

export const maintenanceReportsBridge = react2angular(MaintenanceReports, [
  'selectedBusiness'
]);
